"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vietnam = void 0;
exports.Vietnam = {
    id: 'fhvietnam',
    companyName: 'Vietnam',
    transportModes: ['sea', 'air'],
    freightGate: {
        isOnboarded: true,
        realm: 'fhvietnam',
    },
    isInternal: true,
    isActive: true,
    countries: ['VN'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVmlldG5hbS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9hZ2VudHMvZGF0YS9WaWV0bmFtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsT0FBTyxHQUFVO0lBQzFCLEVBQUUsRUFBRSxXQUFXO0lBQ2YsV0FBVyxFQUFFLFNBQVM7SUFDdEIsY0FBYyxFQUFFLENBQUMsS0FBSyxFQUFFLEtBQUssQ0FBQztJQUM5QixXQUFXLEVBQUU7UUFDVCxXQUFXLEVBQUUsSUFBSTtRQUNqQixLQUFLLEVBQUUsV0FBVztLQUNyQjtJQUNELFVBQVUsRUFBRSxJQUFJO0lBQ2hCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsU0FBUyxFQUFFLENBQUMsSUFBSSxDQUFDO0NBQ3BCLENBQUEifQ==